import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { environment } from 'src/environments/environment';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import {
  CartControllerService,
  CheckoutData,
} from '../../services/cart-controller/cart-controller.service';

@Component({
  selector: 'cart-button',
  imports: [MatButtonModule, MatIconModule, MatBadgeModule],
  templateUrl: './cart-button.component.html',
  styleUrl: './cart-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartButtonComponent implements OnInit, OnDestroy {
  public checkoutData: CheckoutData | undefined = undefined;

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
    private cart: CartControllerService,
    private cd: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.cart._checkoutData$.pipe(takeUntil(this._unsubscribeAll)).subscribe((checkoutData) => {
      this.checkoutData = checkoutData;
      this.cd.markForCheck();
    });
  }
  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    this._unsubscribeAll.unsubscribe();
  }

  public onClickCart(): void {
    const url = `${environment.saleor.storeFront}/cart`;
    window.open(url, '_blank');
  }
}
